import { useEffect, useState } from "react";

interface EmptyProps {
  isCurrentUser: boolean;
  username: string;
}

export default function Empty({ isCurrentUser, username }: EmptyProps) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const messages = isCurrentUser
      ? ["Leave some reviews and let your beautiful voice be heard."]
      : [
          `${username} doesn't want the spooks to know what they're thinking.`,
          `${username} is a person of few words.`,
          `${username} clearly is less opinionated than my Aunt Carol.`,
          `${username} just thinks every experience is a winner.`,
          `${username} is actually a raccoon. Doesn't have opposable thumbs.`,
          `${username} really REALLY doesn't want to spoil anything for others.`,
        ];

    setMessage(messages[Math.floor(Math.random() * messages.length)]);
  }, [isCurrentUser, username]);

  return (
    <>
      <p className="mt-5 text-center text-34/[2em]">🎤</p>
      <p className="text-center text-15/[2em] text-pale-lavender">{message}</p>
    </>
  );
}
